import { down, up} from "styled-breakpoints";
import styled from "styled-components";
import {AuthCustomModal} from "../../layouts/auth/auth.layout.style";


export const Wrapper = styled.div`
    
    ${down("md")} {
        * {
            z-index: 1 !important;
        }

        .modal-content{
            border-radius: 0!important;
            height: 100%!important;
            overflow: hidden;
            max-height: 100%!important;
        }
        .modal {
            position: initial !important;
            height: initial !important;
        }
    }
`

export const CustomModal = styled(AuthCustomModal)`
    .btn-outline-secondary {
        color: var(--color-primary);
        border-color: var(--color-primary);
        font-family: Halenoir;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0%;
        text-align: center;
        vertical-align: middle;
        border-radius: 30px;
        border-width: 1px;
        padding: 12px;
        gap: 8px;
        width: 100%;
        &:active, &:focus-within{
            border-color: var(--color-primary);
            color: var(--color-primary);
        }
    }
    hr{
        margin-top: .5rem;
        margin-bottom: 1rem;
        border-color: rgba(55, 65, 81, 0.5);
        background-color: rgba(55, 65, 81, 0.5);
    }
    .modal-header {
        padding-bottom: 0!important;
        padding-top: 0;
        border-bottom: none !important;
        justify-content: center;
        align-items: center;
        h5 {
            font-weight: 700;
            font-style: Bold;
            leading-trim: NONE;
            line-height: 100%;
            letter-spacing: 0px;
            text-transform: capitalize;
            font-size: 17px;

            ${up("md")} {
                font-size: 24px;

            }

            span.green {
                color: rgba(11, 156, 7, 1);
            }
        }
        .btn-close {
            display: none;
        }
        .close-btn {
            position: absolute;
            top: 4px;
            display: block;
            ${up("md")} {
                top: 7px;
                display: none;
            }
            right: 4px;
            cursor: pointer;
        }
    }
   
    ${down("md")}{
        .modal-content {
            border-radius: 0px!important;
            max-height: 100vh!important;
        }
    }
`;
